module.exports = __webpack_public_path__ + "static/media/splash-image.19189022.png";